export default {
  SUPER_OYO_PITCH_PAGE: '/hotel/:hotel_id/super-oyo/pitch-page'
} as const;
